import { render, staticRenderFns } from "./AssignLicenseVehicle.vue?vue&type=template&id=1075610a"
import script from "./AssignLicenseVehicle.vue?vue&type=script&lang=js"
export * from "./AssignLicenseVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports